export interface BrightyMessage {
    title: string;
    summary: string;
    hidden: boolean
    sources?: string;
    extended_response?: string;
}

export interface UserMessage {
    question: string
    precision: number
    thread_id: string
}

export type MessageType = 'HumanMessage' | 'AIMessage'

export interface SingleMessageDTO {
    type: MessageType
    content: string | BrightyMessage
}

export interface BrightyMessagesResponseDTO {
    messages: {
        [key: string]: BrightyMessage;
    };
}

export interface FindBrightyChatByIdDTO {
    messages: SingleMessageDTO[]
}

export interface BrightyFilters {
    user?: string
    page?: number
    page_size?: number
    thread_id?: number
}

export interface BrightyAnswerDTO {
    title: string
    summary: string
    sources: string
    extended_response: string
}

export type getAllTitlesResponseItemDTO = [string, boolean, string]

export type getAllTitlesResponseDTO = getAllTitlesResponseItemDTO[]

export type TitleResult = {
    id: string;
    title?: string;
    error?: string;
};

export const stageMessages: Record<string, string> = {
    "Attesa": "Attendi...",
    "Elaborazione richiesta": "Ricezione della richiesta… ci sono!",
    "Classificazione domanda": "Identificazione dell’argomento principale...",
    "Ricerca fonti": "Analisi delle fonti e normative rilevanti...",
    "Consultazione strumenti": "Controllo incrociato con i documenti disponibili...",
    "Filtraggio informazioni": "Estrazione dei dati più significativi...",
    "Scrittura bozza": "Riformulazione delle informazioni in modo chiaro...",
    "Revisione critica": "Un ultimo sguardo per essere sicuro di non sbagliare...",
    "Miglioramento risposta": "Preparazione della risposta personalizzata...",
    "Finalizzazione": "Brighty sta rifinendo la risposta per te...",
};